import type { AxiosInstance, AxiosResponse } from 'axios';

export interface OkzChangedDto {
	typ?: 'PFO' | 'PO' | 'FO';
}

export const okzChangedQuery = (
	axiosInstance: AxiosInstance
): Promise<AxiosResponse<OkzChangedDto, void>> =>
	axiosInstance.post('/api/v1/security/okz-changed');

export const removeAccountQuery = (
	axiosInstance: AxiosInstance,
	{
		reason,
	}: {
		reason: string;
	}
): Promise<AxiosResponse<void, void>> =>
	axiosInstance.post(
		'/api/v1/security/remove-account',
		{ duvod: reason },
		{
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		}
	);
